import { render, staticRenderFns } from "./AvatarPlaceholder.vue?vue&type=template&id=2f9d5469&scoped=true"
import script from "./AvatarPlaceholder.vue?vue&type=script&lang=js"
export * from "./AvatarPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./AvatarPlaceholder.vue?vue&type=style&index=0&id=2f9d5469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d5469",
  null
  
)

export default component.exports